import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { OktaAuthService } from 'src/app/services/auth.service';


@Injectable({providedIn: 'root'})
export class OktaAuthGuard implements CanActivate {
  constructor(private okta: OktaAuthService, private router: Router,private toastr:ToastrService) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const authenticated = await this.okta.isAuthenticated();
     const authorized=this.okta.isUserAuthorized(route.data['role'])
    if (authenticated) { 
      if(!authorized)
      {
        this.okta.login('/unauthorized');
        return false;
      }
      return true; 
    }
      this.okta.login(state.url);
    return false;
  }
}